module.exports = __webpack_public_path__ + "img/signIn.13d7ded7.png";